



































import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import PlanosAba from "../tables/PlanosAba.vue";
import Confirm from "@/shared/components/confirm.vue";
import { ConsultoresService } from "@/services/consultores.service";
import { tamCampo } from "@/shared/validators";

@Component({
  components: {
    DataTable,
    Confirm,
    PlanosAba,
  },
})
export default class ResetarSenha extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  msgSenha: string | null = "";
  senha: string | null = "";
  showSucess?: boolean = false;
  showError?: boolean = false;
  valid = false;

  rules = {
    senha: [tamCampo(6)],
  };

  async AlterarSenha() {
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.startLoader();
      const preferencia = await ConsultoresService.AlterarSenha(
        this.idConsultor,
        this.senha!
      ).finally(this.stopLoader);
      if (preferencia) {
        this.msgSenha = "Senha alterada com sucesso";
        this.showSucess = true;
        setTimeout(this.fechaAlertaSenha, 5000);
      } else {
        this.msgSenha = "Não foi possível alterar a senha";
        this.showError = true;
        setTimeout(this.fechaAlertaSenha, 5000);
      }
    }
  }

  fechaAlertaSenha() {
    this.showSucess = false;
    this.showError = false;
  }
}
